import React from 'react';
import { ArrowRightIcon, DownloadIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://matematica-pronta.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Ottieni il pacchetto Matematica Pronta',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2 rounded-full bg-primary px-7 py-[18px] text-center text-[15px] font-bold uppercase leading-tight tracking-[0.04em] text-surface shadow-cta transition-[transform,background-color] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-0.5 hover:bg-primary-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/40 active:translate-y-0 sm:gap-3 sm:px-10 sm:py-5 sm:text-base sm:tracking-[0.05em] ${className}`} data-id="element-39" data-mp="qjiljw5ph845">
      <DownloadIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-40" data-mp="35yqrl5lvkb0v" />
      <span data-id="element-41" data-mp="39xzmidsniey0">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" aria-hidden="true" data-id="element-42" data-mp="39z9jeznrph32" />
    </a>;
}